import { applyActionCode, getAuth } from 'firebase/auth'
import React, { FunctionComponent, useEffect } from 'react'
import ResetPassword from '../ResetPassword'
import SetNewPassword from '../SetNewPassword'
import SignInWithVerification from '../SignInWithVerification'
import * as S from './styled'

type OwnProps = {}

type Props = OwnProps

export const Verification: FunctionComponent<Props> = () => {
  const url = window.location.search
  const queryParams = new URLSearchParams(url)
  const auth = getAuth()
  const code = queryParams.get('oobCode')
  const mode = queryParams.get('mode')

  useEffect(() => {
    if (mode === 'verifyEmail') {
      ac()
    }
    async function ac() {
      await applyActionCode(auth, code!).catch()
    }
  }, [])

  return (
    <S.Container>
      {mode === 'resetPassword' && <SetNewPassword />}
      {mode === 'verifyEmail' && <SignInWithVerification />}
      {/* FORMATTING_FIX */}
    </S.Container>
  )
}

export default Verification
